import React from "react";

function PremiumInvestmentSolutions() {
  return (
    <section className="about_section_three">
      <div className="container">
        <div className="row">
          {/* Left Image */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div
              className="about_left_image"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <figure>
                <img
                  src="/images/resource/home-2.png"
                  alt="About Brain Fintech"
                  style={{ borderRadius: "10px" }}
                />
              </figure>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div
              className="about_right_content"
              data-aos="fade-left"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <div className="section_title">
                <div className="tag_text">
                  <h6>Premium Investment Solutions</h6>
                </div>
                <h2>
                  INVEST WITH{" "}
                  <span style={{ color: "#1959a2" }}>Eco Mantra Capital</span>
                </h2>
                <p>PRIVATE PLACEMENT PROGRAM / PRIVATE EQUITY</p>
              </div>

              {/* Feature Block 1 */}
              <div
                className="feature_block_two"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="500"
                data-aos-delay="100"
              >
                <div className="feature_content">
                  <h4>World Class Fund Manager</h4>
                  <p>
                    Expert financial professionals managing your investments
                    with proven strategies and industry experience.
                  </p>
                  <span>Certified & Regulated</span>
                </div>
              </div>

              {/* Feature Block 2 */}
              <div
                className="feature_block_two"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="500"
                data-aos-delay="200"
              >
                <div className="feature_content">
                  <h4>World Class Algorithm</h4>
                  <p>
                    Cutting-edge technology and sophisticated algorithms
                    optimizing investment performance and risk management.
                  </p>
                  <span>AI-Powered Optimization</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PremiumInvestmentSolutions;
